// extracted by mini-css-extract-plugin
module.exports = {"ellipsisMultiLine":"styles_ellipsisMultiLine__2SI6r"};